import React from "react";
import NumberFormat from "react-number-format";
import {useController} from "react-hook-form";

export const NumberFormField = ({
                                    title,
                                    error,
                                    size,
                                    suffix,
                                    control,
                                    name,
                                    className = "",
                                    classNameEl,
                                    defaultValue,
                                    format,
                                    ...rest
                                }) => {
    const {field, fieldState} = useController({
        control,
        name,
        ...(defaultValue && {defaultValue})
    });
    
    return (
        <div
            className={`form-field-wrapper row  ${className}`}
        >
            {title && <div className="form-field-title col-12">{title}</div>}
            <div className={`form-field-item col-12 ${error ? "has-error" : ""}`}>
                <NumberFormat
                    {...rest}
                    {...format}
                    name={field.name}
                    getInputRef={field.ref}
                    onBlur={field.onBlur}
                    autoComplete="off"
                    placeholder={title}
                    autoCorrect="off"
                    autoCapitalize="none"
                    spellCheck="off"
                    className={`hide-placeholder ${
                        classNameEl
                            ? classNameEl
                            : `ant-input hide-placeholder ${size === "large" ? "ant-input-lg" : ""}`
                    }`}
                    onValueChange={e => field.onChange(e.floatValue || e.value)}
                    value={+field.value}
                    size={size}
                    suffix={suffix}
                />
                
                {fieldState?.error?.message && (
                    <div className="form-field-error">
                        {fieldState.error.message}
                    </div>
                )}
            </div>
        </div>
    );
};
